import { Container, type ContainerProps } from "@mike/crt";

interface PageProps extends ContainerProps {
  children: React.ReactNode;
}

export function Page({ children, ...containerProps }: PageProps) {
  return (
    <Container
      positionType="relative"
      display="flex"
      width="100%"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      {...containerProps}
    >
      {children}
    </Container>
  );
}
